export const HOME = '/'
export const ARTICLES = 'articles'
export const SUPPORT = 'support'
export const UB_SUPPORT = 'ub-support'
